import React from "react";
import Modal from "../../../components/Modal/Modal";

interface ManualCertificateConfirmationModalProps {
  isOpen: boolean;
  email: string;
  productTitle: string;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ManualCertificateConfirmationModal: React.FC<ManualCertificateConfirmationModalProps> = ({
  isOpen,
  email,
  productTitle,
  loading,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="admin-page__confirm-modal">
        <div className="admin-page__confirm-modal-copy">
          <h3>Naudotojas jau sertifikuotas</h3>
          <p>
            El. paštas <strong>{email}</strong> jau turi sertifikato įrašą produkte <strong>{productTitle}</strong>.
          </p>
          <p>Ar tikrai norite registruoti pažymėjimą dar kartą?</p>
        </div>

        <div className="admin-page__confirm-modal-actions">
          <button type="button" onClick={onClose} disabled={loading}>
            Atšaukti
          </button>
          <button
            type="button"
            className="admin-page__button admin-page__button--danger-soft"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Registruojama..." : "Taip, registruoti"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ManualCertificateConfirmationModal;